// Function to copy coupon code
function copyCode(button) {
  const codeElement = button.previousElementSibling;
  const codeToCopy = codeElement.textContent;

  // Create a temporary textarea to copy text
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = codeToCopy;
  document.body.appendChild(tempTextArea);

  // Select and copy the text
  tempTextArea.select();
  document.execCommand("copy");

  // Remove the temporary textarea
  document.body.removeChild(tempTextArea);

  // Change button text temporarily
  button.textContent = "Copied!";
  button.style.backgroundColor = "#a3cf05";

  setTimeout(() => {
    button.textContent = "Copy Code";
    button.style.backgroundColor = "#cff740";
  }, 2000);
}

// Function to toggle full details
function toggleReadMore(link) {
  const fullDetails = link.previousElementSibling;

  if (fullDetails.style.display === "block") {
    fullDetails.style.display = "none";
    link.textContent = "Read More";
  } else {
    fullDetails.style.display = "block";
    link.textContent = "Read Less";
  }
}

// Function to share offer (placeholder)
function shareOffer(shareIcon) {
  const couponCode = shareIcon.previousElementSibling.textContent;
  alert(`Sharing coupon code: ${couponCode}`);
}

// Function to check coupon validity
function checkCouponValidity() {
  const cards = document.querySelectorAll(".coupon-card");
  const currentDate = new Date();

  cards.forEach((card) => {
    const validityStatus = card.querySelector(".validity-status");
    const validTillText = Array.from(card.querySelectorAll(".coupon-details p"))
      .find((p) => p.textContent.includes("Valid till"))
      .textContent.replace("• Valid till ", "");

    const expiryDate = new Date(validTillText);

    if (currentDate <= expiryDate) {
      validityStatus.textContent = "Coupon is Valid ✓";
      validityStatus.classList.add("valid");
      validityStatus.classList.remove("expired");
    } else {
      validityStatus.textContent = "Coupon Expired ✗";
      validityStatus.classList.add("expired");
      validityStatus.classList.remove("valid");
    }
  });
}

// Check coupon validity when page loads
window.onload = checkCouponValidity;
